import React, { useCallback, useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { formatNumber } from "../../../../assets/shared/formatNumber";
import { storageMonedaSigno } from "../../../../assets/shared/sessionData";
import PieChart from "../../../Charts/PieChart";
import Spinner from "../../../UI/Spinner/Spinner";
import { Grid, IconButton, TextField, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { compareByDesc } from "../../../../assets/shared/sorting";
import TableFacturasPendientes from "./TableFacturasPendientes";

const PieFacturasPendientes = (props) => {
  const { facturas, totalFacturas, loading, noBorder, minHeight, estaOculto } = props;

  const isDisabledChart = estaOculto;
  const [items, setItems] = useState([]);
  const [limit, setLimit] = useState(20);
  const chartSinDatos = facturas.length === 0 || (facturas.length === 1 && facturas[0].value === 0);  

  const facturasPositivas = useCallback(() => {
    let facturasPos = facturas ? facturas.filter((vnt) => vnt['value'] >= 0) : [];
    return facturasPos;
  }, [facturas]);

  const getSeries = useCallback(() => {
    let tempItems = limit && limit > 0 ? items : facturasPositivas();
    let series = tempItems ? tempItems.map((factura) => Math.abs(factura.value)) : [];

    return series;
  }, [limit, items, facturasPositivas]);

  const getLabels = useCallback(() => {
    let tempItems = limit && limit > 0 ? items : facturasPositivas();
    let labels = tempItems ? tempItems.map((factura) => factura.name) : [];

    return labels;
  }, [limit, items, facturasPositivas]); 
  
  useEffect(() => {
    if (!loading && limit && limit > 0) {
      let facturas = facturasPositivas();
      let ordered = facturas.sort((a, b) => compareByDesc(a, b, 'monto'));
      let filtered = ordered.slice(0, limit);
      let others = ordered.slice(limit);

      if (others && others.length > 0) {
        let otherItem = {
          mes: others[0].mes,
          anio: others[0].anio,
          monto: 0,
        };
        otherItem['nombre'] = "OTROS";
        otherItem['id'] = "0000";
        others.forEach(element => {
          otherItem.monto += element.monto;
        });
        filtered.splice(0, 0, otherItem);
      }
      setItems(filtered);
    }

  }, [loading, limit, facturasPositivas]);

  //#region Limit

  const onLimitChange = (value) => {
    let numValue = Number(value);
    setLimit(numValue);
  }

  const getLimit = () => {
    return (
      <Grid container direction='row' justifyContent='center' alignItems='center'>
        <Grid item xs={6}>
          <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
            Límite
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <TextField
            value={limit}
            onChange={(event) => onLimitChange(event.target.value)}
            type="number"
            size='small'
            InputProps={{
              inputProps: {
                max: facturas && facturas.length,
                min: 0,
                style: { padding: '2px', textAlign: 'center' }
              }
            }}
          />
        </Grid>
        <Grid item xs={2}>
          {limit && limit > 0 ? (
            <IconButton size='small' onClick={() => setLimit(0)}>
              <Close fontSize='small' />
            </IconButton>
          ) : <Fragment></Fragment>}
        </Grid>
      </Grid>
    )
  }

  //#endregion

  //#region Change View
  const [viewAsPie, setViewAsPie] = useState(true);

  const handleChangeView = () => {
    setViewAsPie(!viewAsPie);
  }

  const dataLabels = {
    enabled: true,
    formatter: function (val, opts) {
      let item = opts.w.config.labels[opts.seriesIndex];

      if (item && item.toUpperCase() === 'OTROS')
        return `OTROS ${formatNumber(val)}%`;
      else
        return `${formatNumber(val)}%`;
    },
  }

  const subTitle = () => {
    return `Total: ${storageMonedaSigno()} ${formatNumber(totalFacturas)}`;
  }

  const renderPie = () => {
    return (
      <PieChart
        title={`Facturas Pendientes`}
        endItems={getLimit()}
        subTitle={subTitle()}
        labels={getLabels()}
        series={getSeries()}
        imgSinDatos={chartSinDatos}
        loading={loading}
        legendPosition={'bottom'}
        chartType="donut"
        legendHorizontalAlign={"left"}
        height={'90%'}
        width={'100%'}
        maxWidthImgSinResult={330}
        noBorder={noBorder}
        minHeight={minHeight}
        onChangeViewClick={handleChangeView}
        dataLabels={dataLabels}
      />
    );
  }

  const renderTable = () => {
    return (
      <TableFacturasPendientes
        title={`Facturas Pendientes`}
        subTitle={subTitle()}
        facturas={facturas}
        totalFacturas={totalFacturas}
        loading={loading}
        onChangeViewClick={handleChangeView}
        height={436}
        disabled={isDisabledChart}
        filename={`Facturas Pendientes`}
      />
    )
  }

  //#endregion

  return loading ? (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <Spinner />
    </div>
  ) : viewAsPie ? (
    <Fragment>
      {renderPie()}
    </Fragment>
  ) : (
    <Fragment>
      {renderTable()}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    facturas: state.ventas.facturasPendientes.facturas,
    totalFacturas: state.ventas.facturasPendientes.totalFacturas,
    estaCargado: state.ventas.facturasPendientes.estaCargado,
    loading: state.ventas.facturasPendientes.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(PieFacturasPendientes);